module.exports = __webpack_public_path__ + "63cc25d9ce939283da1417ca5fbbc952.pdf";